const dispatch = require("~/store.js").dispatch;

const server = require("~/server.js");

const events = require("./userLoadEvents.js");

const userLoadDispatchers = {
    LoadCurrentUser() {
        dispatch((thunkDispatch) => {
            const loading = events.Loading.New();

            thunkDispatch(loading);
            
            server.Get("current-user")
                .then((response) => {
                    return response.json();
                })
                .then((json) => {
                    const loaded = events.Loaded.New(json);

                    thunkDispatch(loaded);
                })
                .catch((ex) => {
                    const errored = events.LoadErrored.New(ex);

                    thunkDispatch(errored);
                });
        });
    }
};

module.exports = userLoadDispatchers;


// WEBPACK FOOTER //
// ./src/events/userLoad/userLoadDispatchers.js